import {ListViewContentElementType} from "../../../enums/listViews/listViewContentElementType";
import {ListViewContentElementCapability} from "./listViewContentElementCapability";
import ListViewContentElementCapabilityManager from "./listViewContentElementCapabilityManager";
import IRepo from "../../../interfaces/repo";
import Repo from "../../../state/modules/repo";
import Provider from "../../../providers/new/provider";
import Selected from "../../../../formability/listViewBuilder/store/modules/selected";
import ListViewContentElementDefinition from "./listViewContentElementDefinition";
import {ListViewContentElementLayoutType} from "../../../enums/listViews/listViewContentElementLayoutType";
import {ArrayHelper} from "../../../helpers/arrayHelper";
import ContentElement from "../../contentManagement/contentElement";
import {ISelectedProperty} from "../../../state/modules/singleSelectedProperty";
import {RelationType} from "../../relationType";
import ListView from "../listView";
import ElementHandler from "../../../services/elementHandler";
import {
  IDerivedValuable,
  IIconImageReferencable,
  IObjectModelPropertyReferenceable,
  ISortedByable
} from "../../../interfaces/propertyInterfaces";
import ObjectModelProperty from "../../objectModelProperties/objectModelProperty";
import {ListViewIconSize} from "../listViewIconSize";
import IConditionalRuleContainer from "../../conditionalRules/conditionalRuleContainer";
import ObjectModelConditionalRuleSet from "../../objectModels/objectModelConditionalRuleSet";
import {ObjectHelper} from "../../../helpers/objectHelper";
import ObjectModelConditionalFields, {ListViewContentElementConditionalField} from "../../objectModels/objectModelConditionalFields";
import ConditionalRuleSetFactory from "../../conditionalRules/conditionalRuleSetFactory";
import ObjectModel from "../../objectModel";
import {Hash} from "../../../interfaces/hashInterfaces";
import ListViewContentElementValidation from "../../navigableValidations/listViewContentElementValidation";
import Validatable from "../../../mixins/validatable";
import {ViewLinkType} from "../viewLinkType";
import {ObjectModelBuiltinPropertyType, ObjectModelBuiltinPropertyTypeName} from "../../../enums/objectModelBuiltinPropertyType";
import {ObjectModelPropertyName, ObjectModelPropertyRootType} from "~/enums/objectModelPropertyType";
import {DatetimeMode} from "~/models/datetimeMode";
import { ReferencePath } from "~/models/referencePaths/referencePath";
import { ReferenceNodeType } from "~/enums/referenceNodeType";
import { ListViewContentElementControlType } from "~/enums/listViews/listViewContentElementControlType";
import ObjectModelPropertyDefinition from "~/models/objectModelProperties/objectModelPropertyDefinition";
import { IReferencePathNodeObjectModelProperty, IReferencePathNodeObjectModelRelation, IReferencePathNodeSpecific, IReferencePathSpecific } from '~/interfaces/referencePathInterfaces'
import { IContentViewModelProperty, IContentViewProperty } from '~/interfaces/contentViewInterfaces'
import ContentViewModelPropertyDefinition from '~/models/contentManagement/contentViewModelPropertyDefinition'
import { IObjectModelActionViewReference } from '~/interfaces/contentManagementInterfaces';

export default class ListViewContentElement extends Validatable(ContentElement) implements ISortedByable, IObjectModelPropertyReferenceable, IDerivedValuable, IIconImageReferencable, IConditionalRuleContainer, IObjectModelActionViewReference {
  rootModel: ListView;
  placeholder_text: string;

  get listView(): ListView {
    return this.rootModel;
  }

  sorted_by_ids: string[];
  /**
   * @deprecated
   */
  property_id: string;
  /**
   * @deprecated
   */
  property_client_id: string;
  builtin_property_type: ObjectModelBuiltinPropertyType | null;
  derived_value: string;
  derived_value_formula: string;
  icon_size: ListViewIconSize;
  referenced_icon_id: string;
  referenced_icon_id_conditional_rule_sets: Hash<ObjectModelConditionalRuleSet>;
  action_client_id: string;
  refresh_page_on_completion: boolean;
  reference_path: IReferencePathSpecific

  linked_view_id: string;
  linked_view_type: ViewLinkType;
  linked_view_title: string;
  except = ['listView', 'createEmbeddedObject', 'organization', 'saveTimer', '_organization'];

  _contentElementHandler: ElementHandler = new ElementHandler(this, ListViewContentElement, 'content_elements');

  static repo: IRepo<ListViewContentElement> = new Repo<ListViewContentElement>('listViewContentElements', ListViewContentElement, {}, new Provider(ListViewContentElement, 'content_element', 'content_elements'));
  repo: IRepo<this, Provider<this>>;

  constructor() {
    super();

    this.defineProperty('placeholder_text', null);
    this.defineProperty('refresh_page_on_completion', false);
    for (const definition of ObjectModelConditionalFields.LIST_VIEW_CONTENT_ELEMENT_FIELDS) {
      const conditionalFieldName = `${definition.fieldName}_conditional_rule_sets`;
      this.except.push(conditionalFieldName);
      this[conditionalFieldName] = {};
      this.createEmbeddedObject[conditionalFieldName] = (parent, json) => {
        return ConditionalRuleSetFactory.createForContainer(this, definition, {}, true, false);
      };
      if (definition.defaultConditionalValue instanceof Function) {
        this.except.push(definition.fieldName);
        this.createEmbeddedObject[definition.fieldName] = definition.defaultConditionalValue;
      }
    }
  }

  get EMBEDDED_MODELS(): { [key: string]: { type: any, relationType: RelationType } } {
    const models = {
      content_elements: {type: ListViewContentElement, relationType: RelationType.dictionary},
      reference_path: {type: ReferencePath, relationType: RelationType.singleObject},

    };
    for (const definition of ObjectModelConditionalFields.LIST_VIEW_CONTENT_ELEMENT_FIELDS) {
      models[`${definition.fieldName}_conditional_rule_sets`] = {type: ObjectModelConditionalRuleSet, relationType: RelationType.dictionary};
      if (definition.defaultConditionalValue instanceof Function) {
        models[definition.fieldName] = {type: Object, relationType: RelationType.singleObject};
      }
    }
    return models;
  }

  createEmbeddedObject = {
    content_elements: (parent: object , json: object): ListViewContentElement => new ListViewContentElement(),
    reference_path: (parent: object, json: {}) => new ReferencePath(parent, json, { nameInParent: 'reference_path', isCollectionRoot: false }).loadFromJson(json),

  };

  initialize(root, parent: any = root, type, json: {} = {}): this {
    super.initialize(root, parent, type, json);

    for (const definition of ObjectModelConditionalFields.LIST_VIEW_CONTENT_ELEMENT_FIELDS) {
      if (definition.defaultConditionalValue instanceof Function) {
        this[definition.fieldName] = definition.defaultConditionalValue(this);
      } else {
        this.defineProperty(definition.fieldName, definition.defaultConditionalValue);
      }
    }

    return this;
  }

  // ******************** VALIDATABLE******************** //
  _validation: ListViewContentElementValidation = new ListViewContentElementValidation(this);

  getDisplayName(propName: string, value?): string {
    switch (propName) {
      case 'property_id':
        return "Property to display";
      case 'linked_view_id':
        return "Linked view"
      case 'linked_view_title':
        return 'Linked view'
      default:
        return propName;
    }
  }
  // ******************** VALIDATABLE END******************** //

  addDefaultProperties(){
    ListViewContentElementCapabilityManager.addDefaultProperties(this);
  }
  addToRepo(): void {
    ListViewContentElement.repo.add(this)
  }

  destroy() {
    if (this.content_type === ListViewContentElementLayoutType.ActionsColumn) {
      this.listView.viewers_can_take_actions = false;
    }

    super.destroy();
  }

  get selector(): ISelectedProperty {
    return Selected.listViewContentElement;
  }

  can(duty: ListViewContentElementCapability): boolean {
    return ListViewContentElementCapabilityManager.can(this.content_type, duty);
  }

  get isSelectable(): boolean {
    return this.can(ListViewContentElementCapability.selectable);
  }

  get isSelected(): boolean {
    return Selected.listViewContentElement.is(this);
  }

  get icon(): string {
    return ListViewContentElementDefinition.getIcon(this.content_type);
  }

  get displayName(): string {
    return ListViewContentElementDefinition.getDisplayName(this.content_type);
  }

  is(...contentTypes: Array<ListViewContentElementType>): boolean {
    return contentTypes.includes(this.content_type);
  }

  isNot(...contentTypes: Array<ListViewContentElementType>): boolean {
    return !this.is(...contentTypes);
  }

  get isDynamicNumerable(): boolean {
    return this.is(ListViewContentElementLayoutType.Column);
  }

  get dynamicNumerableName(): string {
    return ListViewContentElementDefinition.getDisplayName(this.content_type);
  }

  get isMoveDestroyable(): boolean {
    switch (this.content_type) {
      case ListViewContentElementLayoutType.Row:
        // rows are not moveable/destroyable right now (user doesn't know about rows)
        return false;
      case ListViewContentElementLayoutType.Column:
        // can't move/destroy last column in list
        return this.parent.contentElementsArray.length > 1;
      default:
        return true;
    }
  }

  findNearest(contentType: ListViewContentElementType): ListViewContentElement {
    if (!!this.parent && this.parent instanceof ListViewContentElement) {
      return this.parent.is(contentType) ? this.parent : this.parent.findNearest(contentType);
    }
    return null;
  }

  get nearestColumn(): ListViewContentElement {
    if (this.is(ListViewContentElementLayoutType.Column)) {
      return this;
    } else if (this.is(ListViewContentElementLayoutType.ActionsColumn)) {
      return this.parent.nearestColumn;
    } else if (this.is(ListViewContentElementLayoutType.Row)) {
      return ArrayHelper.last(<ListViewContentElement[]>this.contentElementsArray, (el) => el.is(ListViewContentElementLayoutType.Column));
    } else {
      return this.findNearest(ListViewContentElementLayoutType.Column);
    }
  }

  get objectModel(): ObjectModel {
    return this.rootModel.object_model ||  this.listView.published_object_model;
  }

  get possibleSortedByProperties(): ObjectModelProperty[] {
    return this.objectModel.indexedProperties;
  }

  get sortedByProperties(): ObjectModelProperty[] {
    return this.possibleSortedByProperties.filter(p => this.sorted_by_ids.includes(p.client_id));
  }

  get hasProperty(): boolean {
    return !!this.property;
  }

  get property(): IContentViewProperty {
    let referenceNode: IReferencePathNodeSpecific
    if (this.reference_path?.nodes?.length > 0) {
      referenceNode = this.reference_path.nodes[this.reference_path.nodes.length - 1]
    }

    if (referenceNode && isValidModelPropertyNode(referenceNode)) {
      // if pre-loaded on page load
      if (this.reference_path.last_referenced_object) {
        const prop = referenceNode.service.findOrBuildReference(this.reference_path.last_referenced_object)
        if (prop) return prop
      }

      // if selected
      return referenceNode.service.reference()
    }


    return this.objectModel.findObjectModelProperty(this.property_id);
  }

  get modelProperty(): IContentViewModelProperty {
    return this.property && ContentViewModelPropertyDefinition.modelProperty(this.property)
  }

  get propertyIsMappedProperty(): boolean {
    return this.modelProperty?.isMappedProperty
  }

  get propertyDatetimeMode(): DatetimeMode {
    if (this.propertyIsDateTime) {
      if (this.modelProperty) {
        return this.modelProperty.datetimeMode
      } else {
        return DatetimeMode.Datetime
      }
    }
  }

  get hasFormula(): boolean {
    return !!this.derived_value_formula;
  }

  getConditionalRuleSets(fieldName: string): Hash<ObjectModelConditionalRuleSet> {
    return this[`${fieldName}_conditional_rule_sets`];
  }

  getSortedConditionalRuleSets(fieldName: string): ObjectModelConditionalRuleSet[] {
    const ruleSets = this.getConditionalRuleSets(fieldName);
    return ObjectHelper.toArray(ruleSets).sort((x, y) => x.sort_order < y.sort_order ? -1 : 1);
  }

  createNewRuleSet(fieldName: string, definition: ListViewContentElementConditionalField): ObjectModelConditionalRuleSet {
    return new ObjectModelConditionalRuleSet(fieldName, definition);
  }

  getReferencedControl(id: string): ObjectModelProperty {
    return ObjectModelProperty.repo.find(id);
  }

  getReferencableControls(): ObjectModelProperty[] {
    return this.rootModel.object_model.objectModelPropertiesArray;
  }

  get isPinned(): boolean {
    if (this.content_type === ListViewContentElementLayoutType.Column) {
      return this.sort_order + 1 <= this.listView.pin_count;
    } else {
      return false;
    }
  }

  get hasLinkedView(): boolean {
    return this.linkedViewData && (this.linkedViewData.type !== ViewLinkType.none);
  }

  get linkedViewData(): {id: string, type: ViewLinkType, title: string} {
    if (this.linked_view_id) {
      return {
        id: this.linked_view_id,
        type: this.linked_view_type,
        title: this.linked_view_title,
      };
    } else {
      return null;
    }
  }

  get pinnedColumns(): ListViewContentElement[] {
    return this.contentElementHandler.all.filter(ce => ce.isPinned)
  }

  get unpinnedColumns(): ListViewContentElement[] {
    return this.contentElementHandler.all.filter(ce => !ce.isPinned)
  }

  get actionName(): string {
    if (this.is(ListViewContentElementLayoutType.Action)) {
      const objectModel = this.listView.published_object_model || this.listView.object_model;
      const action = objectModel.findObjectModelAction(this.action_client_id);
      return action.label_title;
    }
    return '';
  }

  get builtinPropertyType() {
    const builtIn = this.reference_path?.nodes[this.reference_path.nodes.length - 1]
    if (builtIn && builtIn.reference_type === ReferenceNodeType.ObjectModelRecordMetadata){
      return parseInt(builtIn.reference_id, 10);
    }

    return this.builtin_property_type;
  }

  get propertyIsDateTime(): boolean {
    if (this.modelProperty) {
      return this.modelProperty.isDateTime
    //Handle for built in properties
    } else {
     return this.builtinPropertyType === ObjectModelBuiltinPropertyType.CreatedAt || this.builtinPropertyType === ObjectModelBuiltinPropertyType.UpdatedAt
    }
  }


  get propertyName(): string {
    if (this.reference_path?.lastNode?.service.label) {
      return this.reference_path.nicePathString
    } else if (!!this.modelProperty){
      return this.modelProperty.hasLabelTitle ? this.modelProperty.label_title : "None"
    } else if (this.builtinPropertyType) {
      return ObjectModelBuiltinPropertyTypeName[this.builtinPropertyType];
    }
  }

  get propertyNotConfigured(): boolean {
    return !this.property && !this.builtinPropertyType && !this.reference_path?.lastNode?.service?.label;
  }

  get propertyType(): string {
    if (!!this.modelProperty) {
      return this.modelProperty.name
    } else if (this.builtinPropertyType) {
      switch (this.builtinPropertyType) {
        case ObjectModelBuiltinPropertyType.CreatedBy:
          return ObjectModelPropertyName(ObjectModelPropertyRootType.Text);
        case ObjectModelBuiltinPropertyType.CreatedAt:
        case ObjectModelBuiltinPropertyType.UpdatedAt:
          return ObjectModelPropertyName(ObjectModelPropertyRootType.DateTime);
      }
    }
  }

  get propertyFormat(): string {
    if (this.modelProperty.canHaveFormat) {
      return this.modelProperty.format
    } else {
      return "N/A";
    }
  }

  get propertyCharLimit(): string {
    if (this.modelProperty.canHaveCharacterCount) {
      return this.modelProperty.charLimit
    } else {
      return "N/A";
    }
  }

  get propertyRequired(): string {
    if (!this.modelProperty.canBeRequired) {
      return "N/A"
    }
    return this.modelProperty.is_required ? "Yes" : "No"
  }

  get propertyIndexed(): string {
    if (!this.modelProperty.isIndexable) {
      return "N/A"
    } else {
      return this.modelProperty.isIndexed ? "Yes" : "No"
    }
  }

  get isModelProperty(): boolean {
    return this.content_type === ListViewContentElementControlType.ModelProperty
  }

  get propertyIcon(): string {

    if (this.isNestedReference) {
      return "related-object"
    }

    if (this.modelProperty) {
      return this.modelProperty.icon
    }

    if (this.builtinPropertyType) {
      switch (this.builtinPropertyType) {
        case ObjectModelBuiltinPropertyType.CreatedBy:
          return ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.Text);
        case ObjectModelBuiltinPropertyType.CreatedAt:
        case ObjectModelBuiltinPropertyType.UpdatedAt:
          return ObjectModelPropertyDefinition.getIcon(ObjectModelPropertyRootType.DateTime);
      }
    }
  }

  // does reference path not refer to current object model
  get isNestedReference(): boolean {
    if (!this.reference_path) return false;

    const omIndex = this.reference_path.nodes.length - 2;

    const listViewOMId = this.rootModel.object_model_id;
    const referenceOMId = this.reference_path.nodes[omIndex].reference_id;
    return listViewOMId !== referenceOMId;
  }
}

function isValidModelPropertyNode(node: IReferencePathNodeSpecific): node is IReferencePathNodeObjectModelProperty | IReferencePathNodeObjectModelRelation {
  return node.reference_type === ReferenceNodeType.ObjectModelProperty ||
      node.reference_type === ReferenceNodeType.ObjectModelRelation
}